export default {"src":"/_next/static/media/at-flag.13f4e64f.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};